// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.ScheduledCallViewInfo__name-aa3ebc {
  font: var(--font-title-8);
  color: var(--base-110);
  margin-bottom: 4px;
}

.ScheduledCallViewInfo__time-aed203 {
  font: var(--font-subhead-2);
  color: var(--base-80);
  margin-bottom: 4px;
}

.ScheduledCallViewInfo__reminder-bc7747 {
  font: var(--font-subhead-2);
  color: var(--base-80);
  margin-bottom: 16px;
}

.ScheduledCallViewInfo__reminder-placeholder-dcf64d {
  height: 20px;
  margin-bottom: 16px;
}

.ScheduledCallViewInfo__group-d7925e {
  margin-bottom: 16px;
  display: flex;
  align-items: center;
}

.ScheduledCallViewInfo__avatar-b5224e {
  margin-inline-end: 8px;
}

.ScheduledCallViewInfo__group-name-dff9ed {
  font: var(--font-body-5);
  letter-spacing: var(--font-spacing-body-5);
  color: var(--base-80);
}

.ScheduledCallViewInfo__actions-aaf5bb {
  display: flex;
}

.ScheduledCallViewInfo__action-button-e64343 {
  margin-inline-start: 16px;
}`, "",{"version":3,"sources":["webpack://./src/main/PopupManager/Popups/ScheduledCalls/ScheduledCallViewPopup/ScheduledCallViewInfo/ScheduledCallViewInfo.styles.m.css"],"names":[],"mappings":"AAAA;EACE,yBAAA;EACA,sBAAA;EACA,kBAAA;AACF;;AAEA;EACE,2BAAA;EACA,qBAAA;EACA,kBAAA;AACF;;AAEA;EACE,2BAAA;EACA,qBAAA;EACA,mBAAA;AACF;;AAEA;EACE,YAAA;EACA,mBAAA;AACF;;AAEA;EACE,mBAAA;EACA,aAAA;EACA,mBAAA;AACF;;AAEA;EACE,sBAAA;AACF;;AAEA;EACE,wBAAA;EACA,0CAAA;EACA,qBAAA;AACF;;AAEA;EACE,aAAA;AACF;;AAEA;EACE,yBAAA;AACF","sourcesContent":[".name {\n  font: var(--font-title-8);\n  color: var(--base-110);\n  margin-bottom: 4px;\n}\n\n.time {\n  font: var(--font-subhead-2);\n  color: var(--base-80);\n  margin-bottom: 4px;\n}\n\n.reminder {\n  font: var(--font-subhead-2);\n  color: var(--base-80);\n  margin-bottom: 16px;\n}\n\n.reminder-placeholder {\n  height: 20px;\n  margin-bottom: 16px;\n}\n\n.group {\n  margin-bottom: 16px;\n  display: flex;\n  align-items: center;\n}\n\n.avatar {\n  margin-inline-end: 8px;\n}\n\n.group-name {\n  font: var(--font-body-5);\n  letter-spacing: var(--font-spacing-body-5);\n  color: var(--base-80);\n}\n\n.actions {\n  display: flex;\n}\n\n.action-button {\n  margin-inline-start: 16px;\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"name": `ScheduledCallViewInfo__name-aa3ebc`,
	"time": `ScheduledCallViewInfo__time-aed203`,
	"reminder": `ScheduledCallViewInfo__reminder-bc7747`,
	"reminder-placeholder": `ScheduledCallViewInfo__reminder-placeholder-dcf64d`,
	"reminderPlaceholder": `ScheduledCallViewInfo__reminder-placeholder-dcf64d`,
	"group": `ScheduledCallViewInfo__group-d7925e`,
	"avatar": `ScheduledCallViewInfo__avatar-b5224e`,
	"group-name": `ScheduledCallViewInfo__group-name-dff9ed`,
	"groupName": `ScheduledCallViewInfo__group-name-dff9ed`,
	"actions": `ScheduledCallViewInfo__actions-aaf5bb`,
	"action-button": `ScheduledCallViewInfo__action-button-e64343`,
	"actionButton": `ScheduledCallViewInfo__action-button-e64343`
};
module.exports = ___CSS_LOADER_EXPORT___;
